import React, { useEffect, useState } from 'react';
import '../style.css';
import serviceData from '../data.json';

function Services() {
  const [services, setServices] = useState([]);

  useEffect(() => {
    if (serviceData.services) {
      setServices(serviceData.services);
    }
  }, []);

  return (
    <div className="container my-5">
      <h2 className="text-center mb-4" data-aos="fade-down">🛠️ Our Services</h2>
      <div className="row">
        {services.map((service, index) => (
          <div className="col-md-4 mb-4" key={index} data-aos="fade-up">
            <div className="card h-100 shadow-sm">
              <img
                src={service.image}
                className="card-img-top"
                alt={service.title}
                style={{ height: '220px', objectFit: 'cover' }}
              />
              <div className="card-body">
                <h5 className="card-title">{service.title}</h5>
                <p className="card-text">{service.details}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Services;
